import * as React from 'react';
import { formatMessageBundle } from '@unifocus/js-utils';
import messages from '../../../localized-messages';
import { NavBarButton } from './NavBarButton';

/**
 * {@docCategory NavBar}
 */
export interface NavBarCancelButtonProps {
   /**
    * The title of the button.
    * @defaultvalue Cancel
    */
   text?: string;

   /**
    * Called when the back button is clicked.
    */
   onClick: () => void;
}

export const NavBarCancelButton = (props: NavBarCancelButtonProps) => {
   return (
      <NavBarButton onClick={props.onClick}>
         {props.text || formatMessageBundle(messages, 'res_cancel')}
      </NavBarButton>
   );
};
